import React from 'react';
import Box from '@mui/material/Box';
import CustomTypography from '@ui-components/Typography/CustomTypography'; // Adjust the import path as needed

const QlerFooter: React.FC = () => {
  return (
    <Box className="qler-footer">
      <CustomTypography
        variant="body2"
        id="privacyPolicy"
        color="textSecondary"
        className="pb-md"
      >
        Privacy Policy
      </CustomTypography>
    </Box>
  );
};

export default QlerFooter;
